import { gql } from '@apollo/client'

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  recommendationId: string
  recommendationType: string
  notifyApplicant?: boolean
}

export type Response = {
  cancelDataRequest: string
}

const mutation = gql`
  mutation cancelDataRequest(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $recommendationId: String!
    $recommendationType: String!
    $notifyApplicant: Boolean
  ) {
    cancelDataRequest(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      recommendationId: $recommendationId
      recommendationType: $recommendationType
      notifyApplicant: $notifyApplicant
    )
  }
`

export default mutation
